import * as yup from 'yup';
export const LOCAL_STORAGE_KEY = 'ai-interview-formData';
export const LOCAL_STORAGE_STEP_KEY = 'ai-interview-step';
export const OBJECTIVES_LOADER_TEXT = "Generating Objectives...";
export const companySize = [
    { label: "0-50", value: "0-50" },
    { label: "50-100", value: "50-100" },
    { label: "100-200", value: "100-200" },
    { label: "200-500", value: "200-500" },
    { label: "500-1000", value: "500-1000" },
    { label: "1000+", value: "1000+" },
];
export const organizationType = [
    {
        value: "Private Limited Companies",
        label: "Private Limited Companies",
    },
    {
        value: "Public Limited Companies",
        label: "Public Limited Companies",
    },
    {
        value: "Statutory Companies",
        label: "Statutory Companies",
    },
    {
        value: "Companies Limited by Shares",
        label: "Companies Limited by Shares",
    },
    {
        value: "Companies Limited by Guarantee",
        label: "Companies Limited by Guarantee",
    },
    {
        label: "Royal Chartered Companies",
        value: "Royal Chartered Companies",
    },
    {
        value: "Registered or Incorporated Companies",
        label: "Registered or Incorporated Companies",
    },
    {
        value: "Unlimited Companies",
        label: "Unlimited Companies",
    },
    {
        value: "Sole Proprietorship",
        label: "Sole Proprietorship",
    },
    {
        value: "Subsidiary Companies",
        label: "Subsidiary Companies",
    },
    {
        value: "Associate Companies",
        label: "Associate Companies",
    },
    {
        value: "Holding Companies",
        label: "Holding Companies",
    },
    {
        value: "Institute",
        label: "Institute",
    },
];
export const numberOnlyForMobile = (event) => {
    let digitPeriodRegExp = new RegExp("\\d|\\.");
    if (event.ctrlKey || event.altKey || typeof event.key !== "string" || event.key.length !== 1) {
        return;
    }
    if (!["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(event.key)) {
        event.preventDefault();
    }
};
export const isNumeric = (val) => /^\d+$/.test(val);
export const capitalizeFirst = (str) => str.charAt(0).toUpperCase() + str.slice(1);
/**
 * Build a filesystem-safe download filename.
 *
 * Browsers/OSes reject or mangle names containing `: / \ ? * | < > "` (a colon
 * from a time like "5:59 PM" is the common offender), which made report/summary
 * downloads fail or save as unopenable files on Windows/macOS and non-Chrome
 * browsers. This joins the given parts, strips invalid characters, collapses
 * whitespace/commas to underscores, trims length, and appends the extension
 * exactly once. Empty/invalid parts (e.g. an "Invalid Date") are dropped.
 */
export const safeFileName = (parts, extension = 'pdf') => {
    const cleaned = parts
        .map((p) => (p == null ? '' : String(p)))
        .map((p) => (p.toLowerCase() === 'invalid date' ? '' : p))
        .map((p) => p
        // characters illegal in file names on common OSes
        .replace(/[:/\\?*|<>"]/g, ' ')
        // commas + collapse any whitespace run to a single space
        .replace(/[,]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim())
        .filter(Boolean)
        .join('_')
        // spaces -> underscores for a clean, portable name
        .replace(/\s/g, '_')
        // collapse repeated separators
        .replace(/_{2,}/g, '_')
        .replace(/^[_\-.]+|[_\-.]+$/g, '');
    const base = (cleaned || 'download').slice(0, 180);
    const ext = extension.replace(/^\.+/, '');
    return `${base}.${ext}`;
};
export const preventEvent = (e) => {
    e.preventDefault();
    return false;
};
export const mobileVerificationalidationSchema = () => {
    return yup.object().shape({
        mobile: yup
            .string()
            .trim()
            .required("Required")
            .min(10, "Phone number must be 10 digits")
            .max(10, "Must be exactly 10 digits")
            .test("contact", "Extra space not allowed", (value) => {
            var _a, _b;
            const space = (_b = (_a = value === null || value === void 0 ? void 0 : value.trim()) === null || _a === void 0 ? void 0 : _a.split(" ")) === null || _b === void 0 ? void 0 : _b.length;
            return space >= 1;
        })
            .test("contact", "Required", (value) => {
            var _a;
            return ((_a = value === null || value === void 0 ? void 0 : value.trim()) === null || _a === void 0 ? void 0 : _a.length) >= 1;
        }),
    });
};
export const mobileVerificationOTPValidationSchema = () => {
    return yup.object().shape({
        otp: yup.string().trim().required("Required").min(6, "OTP must be 6 digits").max(6, "OTP must be 6 digits"),
    });
};
